module.exports = __webpack_public_path__ + "static/media/jared.b2a60957.jpg";